/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-11-07",
    versionChannel: "nightly",
    buildDate: "2024-11-07T00:06:13.866Z",
    commitHash: "99f6b222850f59868c7fae3e20230ddce65edfb8",
};
